.form {
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--sp-5);
}

@media (max-width: 560px) {
  .row {
    grid-template-columns: 1fr;
  }
}

.field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.num {
  width: 7em;
}

.textarea {
  min-height: 96px;
  resize: vertical;
}

.switchRow {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  cursor: pointer;
}

.stayBlock {
  display: flex;
  flex-direction: column;
  gap: var(--sp-2);
}

.stayRow {
  display: flex;
  gap: var(--sp-5);
}

.stayField {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
}

.stayLabel {
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.hint {
  margin: 0;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.offBanner {
  margin: 0;
  padding: var(--sp-3) var(--sp-4);
  background: var(--surface-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.warnBanner {
  margin: 0;
  padding: var(--sp-3) var(--sp-4);
  background: var(--warn-bg);
  border: var(--bw) solid var(--warn-border);
  border-radius: var(--radius);
  color: var(--warn);
  font-size: var(--fs-sm);
}

.errorBanner {
  margin: 0;
  padding: var(--sp-4) var(--sp-5);
  background: var(--error-bg);
  border: var(--bw) solid var(--error-border);
  border-radius: var(--radius);
  color: var(--error);
  font-size: var(--fs-sm);
}

/* ── Результат ────────────────────────────────────────────────────────── */
.result {
  display: flex;
  flex-direction: column;
  gap: var(--sp-5);
}

.caption {
  margin: 0;
  font-weight: 600;
}

.modelLine {
  margin: 0;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.notesBlock {
  padding: var(--sp-4) var(--sp-5);
  background: var(--surface-2);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius);
}

.notesTitle {
  margin: 0 0 var(--sp-2);
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text-2);
}

.notes {
  margin: 0;
  padding-left: var(--sp-5);
  color: var(--text-2);
  font-size: var(--fs-sm);
  list-style: disc;
}

.notes li + li {
  margin-top: var(--sp-1);
}

.card {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  padding: var(--sp-5);
  border: var(--bw) solid var(--border);
  border-radius: var(--radius-lg);
  background: var(--surface);
}

.cardHead {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--sp-4);
}

.include {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  cursor: pointer;
  min-width: 0;
}

.cardName {
  font-size: var(--fs-lg);
  font-weight: 600;
}

.total {
  flex: 0 0 auto;
  font-weight: 600;
}

.summary {
  margin: 0;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.segments {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
}

/* Разделители между блоками — всегда волосок, как и на таймлайне. */
.segment {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--sp-4);
  padding: var(--sp-2) 0;
}

.segment + .segment {
  border-top: 1px solid var(--border);
}

.segTitle {
  font-size: var(--fs-md);
}

.segSub {
  color: var(--text-2);
  font-size: var(--fs-sm);
  text-align: right;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-4);
  margin: 0;
  color: var(--text-2);
  font-size: var(--fs-sm);
}

.metaItem {
  white-space: nowrap;
}

.cardNotes {
  margin: 0;
  padding-left: var(--sp-5);
  color: var(--text-2);
  font-size: var(--fs-sm);
  list-style: disc;
}

.cardNotes li + li {
  margin-top: var(--sp-1);
}

.noteWarn {
  color: var(--warn);
}

.noteError {
  color: var(--error);
}
